function init() {
  var $layouts = $('.layout-text-with-media');

  $layouts.each(function() {
    var $layout = $(this);
    var $modal = $layout.find('.modal');
    var $modalBody = $modal.find('.modal-body');

    $modal.on('hidden.bs.modal', function() {
      $modal.find('iframe').each(function() {
        var src = $(this).attr('src');
        $(this).attr('src', '');
        $(this).attr('src', src);
      });
    });
  });

  // window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=carousel', function(response, $flexible, $layout, ajaxData) {
  //   $layout.find('.carousel').each(function() {
  //     new Flickity($(this).get(0));
  //   });
  // });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/textWithMedia.js